const IMAGE_HOST = 'static.battleverse.cn';
export const THUMBNAIL_PROCESS = 'image/resize,m_lfit,w_640,h_640,limit_1/quality,q_80/format,webp';

export function getWorkThumbnailUrl(source) {
  if (!source || /^(data:|blob:)/i.test(source)) return source || '';
  try {
    const url = new URL(source, `https://${IMAGE_HOST}/`);
    if (!['http:', 'https:'].includes(url.protocol) || url.hostname !== IMAGE_HOST) return source;
    // Animated WebP cannot be reliably distinguished by its URL; keep its original frames.
    if (/\.webp$/i.test(url.pathname)) return url.href;
    // Existing transforms may contain a watermark or a crop; preserve their meaning.
    if (url.searchParams.has('x-oss-process')) return url.href;
    url.protocol = 'https:';
    const process = /\.gif$/i.test(url.pathname)
      ? 'image/resize,m_lfit,w_640,h_640,limit_1'
      : /\.jpe?g$/i.test(url.pathname)
        ? THUMBNAIL_PROCESS.replace('image/', 'image/auto-orient,1/')
        : THUMBNAIL_PROCESS;
    url.searchParams.set('x-oss-process', process);
    return url.href;
  } catch {
    return source;
  }
}

// A shared queue survives React renders and caps visible thumbnail transfers per page.
const pending = [];
let active = 0;
const LIMIT = 4;
function drain() {
  while (active < LIMIT && pending.length) {
    const job = pending.shift();
    if (job.cancelled) continue;
    job.active = true;
    active += 1;
    job.start(job.release);
  }
}
export function queueThumbnail(start) {
  const job = { start, active: false, cancelled: false, released: false };
  job.release = () => {
    if (job.released) return;
    job.released = true;
    if (job.active) active -= 1;
    Promise.resolve().then(drain);
  };
  pending.push(job);
  drain();
  return () => {
    job.cancelled = true;
    const index = pending.indexOf(job);
    if (index >= 0) pending.splice(index, 1);
    job.release();
  };
}
